<app-gold-line input_position="start" />
<div class="category_card">
  <div
    class="category_card__image"
    [style.backgroundImage]="'url(' + MenuItem.imageUrl + ')'"
  ></div>
  @if(price){
  <div class="category_card__infoContainer">
    <div class="category_card_infoContainer__title">{{ menuItemName }}</div>
    <div class="category_card_infoContainer__price">{{ price }} TL</div>
  </div>
  <app-counter
    input_color="blue"
    [id]="MenuItem.id"
    class="counter"
    [price]="price"
  />
  } @else {
  <div class="category_card__infoContainer">
    <div class="category_card_infoContainer__title">{{ menuItemName }}</div>
    <div class="category_card_infoContainer__price">{{ menuItemPrice }} TL</div>
  </div>
  <app-counter
    input_color="blue"
    [id]="MenuItem.id"
    class="counter"
    [price]="menuItemPrice"
  />
  }
</div>
<app-gold-line input_position="end" />
